/**
 * This drives CSS-friendly custom file inputs that appear in CF7 forms.
 * See SCSS file _custom-file-input.scss.
 *
 * Example CF7 code:
 
<div class="cf-inputs">
	<div class="cf-file-inputs">
	        <div class="cf-file-input-label-button"><div>File Upload</div></div>
	        <div class="cf-file-list"></div>
	        <div class="cf-file-list-max-reached">Maximum number of files reached</div>
	        <div class="cf-file-form-inputs">[file file_1] [file file_2] [file file_3]</div>
	</div>
    <div class="cf-input-section">
        <div>[submit "Send"]</div>
    </div>
</div>

 * 
 */


import { each, escape } from "lodash";
declare const jQuery: any;
const $ = jQuery;

const $body = $("body");

export function initCf7FileInputs(): void
{
	$(".wpcf7-form").each(function () {
		const $form = $(this);
		setupFileInputs($form);
	});
}	

function setupFileInputs($form): void
{
	const $fileInputs = $form.find(`input[type="file"]`);

	if ($fileInputs.length < 1)
	{
		return;
	}

	const $list = $form.find(`.cf-file-list`);
	const $btn = $form.find(`.cf-file-input-label-button`);
	const $maxReached = $form.find(`.cf-file-list-max-reached`);

	const getEmptyFileInput = () => {
		let $input: any = undefined;
		$fileInputs.each(function () {
			const fileData = this.files[0];
			if (!fileData)
			{
				$input = $(this);
				return false;
			}
		});
		return $input;
	};

	const removeListItem = (index: number) => {
		$list.find(`[data-index="${index}"]`).remove();
	};

	const resetFileInput = (fileInput) => {
		fileInput.value = "";
		fileInput.type = "";
		fileInput.type = "file";
	};

	const clearListItemsForEmptyInputs = () => {
		$fileInputs.each(function (index: number) {
			if (!this.files[0])
			{
				removeListItem(index);
			}
		});
	};

	const addListItem = (index: number, fileData): void => {
		const name: string = escape(fileData.name);
		const html = `<div class="cf-file-list-item" data-index="${index}"><div>${name}</div></div>`;
		const $item = $(html);
		const $removeBtn = $(`<div class="cf-file-list-item-remove" title="Click to remove file"></div>`);
		$removeBtn.on("click", () => {
			removeListItem(index);
			resetFileInput($fileInputs[index]);
			updateButtonDisabledState();
			updateMaxReachedState();
		});
		$item.append($removeBtn);
		$list.append($item);
	};

	const updateButtonDisabledState = () => {
		if (getEmptyFileInput())
		{
			$btn.removeClass("disabled");
		}
		else
		{
			$btn.addClass("disabled");
		}
	}

	const updateMaxReachedState = () => {
		if (getEmptyFileInput())
		{
			$maxReached.removeClass("show");
		}
		else
		{
			$maxReached.addClass("show");
		}
	};

	$fileInputs.each(function (index: number) {
		const fileInput = this;
		const fileData = fileInput.files[0];
		if (fileData)
		{
			addListItem(index, fileData);
		}

		$(fileInput).on("change", function () {
			const fileData = fileInput.files[0];
			removeListItem(index);
			if (fileData)
			{
				addListItem(index, fileData);
				updateButtonDisabledState();
				updateMaxReachedState();
			}
		});
	});

	updateButtonDisabledState();
	updateMaxReachedState();

	$btn.on("click", function () {
		const $fileInput = getEmptyFileInput();
		if ($fileInput)
		{
			$fileInput.click();
		}
	});

	$form.closest(".wpcf7").on("wpcf7submit", function () {
		setTimeout(function () {
			clearListItemsForEmptyInputs();
			updateButtonDisabledState();
			updateMaxReachedState();
		}, 100);
	});
}
